import { render, staticRenderFns } from "./FormLoad.vue?vue&type=template&id=069e05ff&"
import script from "./FormLoad.vue?vue&type=script&lang=js&"
export * from "./FormLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../var/www/transport-app/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports